













































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { UseCollection } from "@/common/composition/use-collection";
import { get_table_config } from "./table.config";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
} from "@vue/composition-api";
import { EventBus } from "@/eventbus";
import TableRow from "./TableRow.vue";
import { delayBy, emptyFn } from "@/fp";
import { ModalProps, ModalType } from "./model";
import { SharedState } from "@/common/state";
import { CoordinateInputTier3, TimeAxisRangeInput } from "@/gql/types";
import { pxToRem } from "@/common/dom.functions";
import { bus_confidence_listener } from "@/common/event-bus-callbacks/confidence";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import { UseTabs } from "@/common/composition/use-tabs";
import { POPULATION_TYPE } from "@/common/models";
import { get_tabs } from "./tabs.config";
import { bus_entity_menu_listener } from "@/common/event-bus-callbacks/entity-menu";
import { get_finding_entities } from "@/common/api/findings/findings.api";
import { FindingObjectType } from "@/common/api/findings/findings.model";
export default Vue.extend({
  components: {
    Modal,
    VirtualTable,
    SimpleNavTabs,
  },
  props: ["modalData"],
  setup(props) {
    const modal_config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      backdropDismiss: true,
      width: "100rem",
      height: Math.min(65, pxToRem(innerHeight) * 0.9) + "rem",
    };

    const table_config = ref(get_table_config(POPULATION_TYPE.FILE));
    const time_frame = computed(() => {
      const { from, type } = SharedState.selectedTimeFrameOption.value;
      return { type, values: [from] } as TimeAxisRangeInput;
    });

    const modal_data = computed(() => props.modalData as ModalProps);
    const current_title = computed(
      () => modal_data.value.titles[selected_tab.value.id]
    );

    const filter_cords: Ref<CoordinateInputTier3[]> = ref([]);

    const tabs_seed = get_tabs(modal_data.value.tabs);
    const [tabs, selected_tab, _set_selected_tab] = UseTabs(
      tabs_seed,
      tabs_seed[0]
    );

    const modal_type_to_finding_object_type = (
      model_type: ModalType
    ): FindingObjectType => {
      switch (model_type) {
        case POPULATION_TYPE.FILE:
        default:
          return "File";
      }
    };

    const {
      items,
      is_loading,
      has_more,
      clear,
      load_items,
      load_more_items,
      has_no_results,
      switch_source,
    } = UseCollection<any, { cursor: string }>(async ({ cursor }) => {
      if (modal_data.value.mock_data) {
        await delayBy(1000);
        return {
          success: true,
          value: {
            cursor: "",
            objects: modal_data.value.mock_data,
          },
        };
      } else {
        return await get_finding_entities(
          modal_type_to_finding_object_type(modal_data.value.tabs[0])
        )({ ...modal_data.value.input, cursor });
      }
    });

    const set_selected_tab = (tab: {
      id: ModalType;
      name: string;
      icon: string;
    }) => {
      _set_selected_tab(tab);
      table_config.value = get_table_config(tab.id);
      switch_source(
        async ({ cursor }) =>
          await get_finding_entities(
            modal_type_to_finding_object_type(tab.id)
          )({ ...modal_data.value.input, cursor })
      );
      load_items({ cursor: "" });
    };

    const on_filters_changed = async (
      cords_from_filter: CoordinateInputTier3[]
    ) => {
      filter_cords.value = [...cords_from_filter];
      clear();
      await load_items({ cursor: "" });
    };

    const subs = {
      switch: emptyFn(),
      confidence: emptyFn(),
      show_menu: emptyFn(),
    };

    onMounted(async () => {
      await load_items({ cursor: "" });
      const [event_name, handler] = bus_entity_menu_listener();
      subs.show_menu = EventBus.listen(event_name, handler);
      const [conf_event_name, conf_handler] = bus_confidence_listener();
      subs.confidence = EventBus.listen(conf_event_name, conf_handler);
    });
    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      time_frame,
      modal_config,
      table_config,
      filter_cords,
      TableRow,
      is_loading,
      has_no_results,
      items,
      load_more_items,
      has_more,
      on_filters_changed,
      tabs,
      selected_tab,
      set_selected_tab,
      current_title,
    };
  },
});
